import { Children, type FC, type ReactNode } from "react";
import { styled } from "~/common/mui";

interface FormSectionProps extends Omit<JSX.IntrinsicElements["div"], "title"> {
  title?: ReactNode;
  className?: string;
  children?: ReactNode;
}

export const FormSection: FC<FormSectionProps> = ({ children, title, className, ...rest }) => {
  return (
    <FormSectionRoot className={className} {...rest}>
      {title && <FormSectionTitle>{title}</FormSectionTitle>}
      {Children.map(children, (child) => child && <FormSectionField>{child}</FormSectionField>)}
    </FormSectionRoot>
  );
};

const FormSectionRoot = styled("div")(({ theme }) => ({
  marginBottom: theme.spacing(3.75),
}));

const FormSectionTitle = styled("h3")(({ theme }) => ({
  ...theme.typography.titleLarge,
  marginTop: 0,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up("tablet")]: {
    ...theme.typography.headlineSmall,
    marginBottom: theme.spacing(3),
  },
}));

const FormSectionField = styled("div")(({ theme }) => ({
  marginBottom: theme.spacing(2),
  width: "100%",
  [theme.breakpoints.up("desktop-s")]: {
    width: "unset",
  },
}));
